export default __webpack_public_path__ + "static/media/icon_intelligence_logical.54379da4.svg";